import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader-mod/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "true",
  "use": "true-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"true\"><defs><style></style></defs><path d=\"M392.596 742.664l518.248-518.248c10.91-10.91 28.55-10.873 39.452.029 10.88 10.88 10.916 28.565.029 39.452L414.673 799.55c-5.814 5.814-13.541 8.52-21.141 8.128-7.477.535-15.151-1.924-21.068-7.44L74.411 522.297c-11.288-10.525-11.893-28.222-1.4-39.476 10.516-11.275 28.194-11.881 39.479-1.357l280.106 261.2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol